import { SpeakingSessionExaminerAvailabilityDto } from "api/planning";
import { List, Popup, Label, Icon } from "semantic-ui-react";
import { ExaminerAvailabilityFilterType } from "./ManageExaminerToRoomStructureFilterBar";
import { ManageExaminerToRoomStructurePopup } from "./ManageExaminerToRoomStructurePopup";
import { getExaminerAvailabilityDisplay } from "./utils/examinerAvailabilityDisplay";

export type ExaminerListItem = {
  id: number;
  examinerNumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  availability: ExaminerAvailabilityFilterType;
  districtId?: number;
  availabilities?: SpeakingSessionExaminerAvailabilityDto[];
  unavailabilities?: SpeakingSessionExaminerAvailabilityDto[];
};

export type Props = {
  examiner: ExaminerListItem;  
  selectedExaminerId?: number;

  onExaminerSelect: (examinerId: number) => void;
};

export const ManageExaminerToRoomStructureExaminerListItem = ({ examiner, selectedExaminerId, onExaminerSelect }: Props) => {
  const { icon, color, labelText, popupHeader, popupDescription } = getExaminerAvailabilityDisplay(examiner.availability);

  return (
    <List.Item
      active={selectedExaminerId === examiner.id}
      onClick={() => onExaminerSelect(examiner.id)}>
      <List.Header>
        {examiner.firstName} {examiner.lastName} ({examiner.examinerNumber})

        <Popup
          position='top center'
          content={
            <ManageExaminerToRoomStructurePopup
              icon={icon}
              color={color}
              header={popupHeader}
              description={popupDescription}
              availabilities={examiner.availabilities}
              unavailabilities={examiner.unavailabilities} />
          }
          trigger={
            <div style={{ float: "right" }}>
              <Label size="mini" color={color}>
                <Icon name={icon} />
                {labelText}
              </Label>
            </div>
          }
        />
      </List.Header>
      <List.Description>{examiner.email}</List.Description>
    </List.Item>
  );
};